<template>
    <div>
        <router-view name="dialog"></router-view>
        <router-view></router-view>
    </div>
</template>

<script>
export default {};
</script>
